export default __webpack_public_path__ + "static/0250-3564815f5f1aafbdb2654f6b9bdbcfba.png";